import React, { useState } from 'react';
import { 
  Button,
  FormControl,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  FormGroup,
  TextareaAutosize,
  Grid,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles'
//import { DropzoneDialog } from 'material-ui-dropzone';
import api from '../../services/api';
import * as yup from 'yup';

import {
  AreaDentes,
  EspacoDente1,
  EspacoDente2,
  EspacoDente3,
  EspacoDente4,
} from './styles';
import MultiFileUpload from '../../components/MultiFileUpload';
import Overlay from '../../components/Overlay';
import StdTextField from '../../components/StdTextField'

let schema = yup.object().shape({
  email: yup.string().email(),
});

const useStyles = makeStyles(theme => ({
  form: {
  },
  textFieldRoot: {
    margin: theme.spacing(1),
    width: '90%',
  },
  notchedOutline: {
    borderColor: 'white',
    '&:hover': { borderColor: 'white' }
  },
  inputLabel: {
    color: 'white'
  },
  input: {
    color: 'white'
  },
  radioGroup: {
    margin: theme.spacing(1),
  },
  radioButton: {
    color: 'white'
  },
  radioButtonChecked: {
    color: '#c358d4'
  },
  formLabel: {
    color: 'white'
  },
  teethRegionsContainer: {
    margin: '15px '
  },
  textarea: {
    width: '90%',
    backgroundColor: 'transparent',
    color: 'white',
    border: '1px solid white',
    borderRadius: '3px',
    padding: '6px 10px',
    margin: theme.spacing(1)
  },
  textareaLabel: {
    color: 'white',
    margin: theme.spacing(1)
  },
  button: {
    margin: theme.spacing.unit,
    background: '#c358d4',
    fontWeight: 'bold',
    color: 'white',
    fontSize: 12,
    width: '100%',
    textAlign: 'center',
    '&:hover': {
      background: '#942ba5'
    }
  }
}))

export default function Home() {
  const classes = useStyles()

  const radioClasses = {
    root: classes.radioButton,
    checked: classes.radioButtonChecked
  }

  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [telefone, setTelefone] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [documento, setDocumento] = useState('');
  const [nomepaciente, setNomePaciente] = useState('');
  const [tipodecaso, setTipoDeCaso] = useState('');
  const [marca, setMarca] = useState('');
  const [modelo, setModelo] = useState('');
  const [tipodeprotese, setTipoDeProtese] = useState('');
  const [coroasprovisoario, setCoroaProvisoria] = useState('');
  const [observacao, setObservacao] = useState('');
  const [formaenvio, setFormaEnvio] = useState('');
  const [linkwetransfer, setLinkWetransfer] = useState('');
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([])
  const [uploading, setUploading] = useState(false)
  const [formCreated, setFormCreated] = useState(false)
  const [formError, setFormError] = useState(false)
  const [regiao, setRegiao] = useState({
    dezoito: false,
    dezesete: false,
    dezeseis: false,
    quinze: false,
    quatorze: false,
    treze: false,
    doze: false,
    onze: false,
    vinteum: false,
    vintedois: false,
    vintetres: false,
    vintequatro: false,
    vintecinco: false,
    vinteseis: false,
    vintesete: false,
    vinteoito: false,
    quarentaoito: false,
    quarentasete: false,
    quarentaseis: false,
    quarentacinco: false,
    quarentaquatro: false,
    quarentatres: false,
    quarentadois: false,
    quarentaum: false,
    trintaum: false,
    tristadois: false,
    trintatres: false,
    trintaquatro: false,
    trintacinco: false,
    trintaseis: false,
    trintasete: false,
    trintaoito: false,
  });

  const HadleRegiao = (e) => {
    setRegiao({ ...regiao, [e.target.name]: e.target.checked });
  };

  const {
    dezoito,
    dezesete,
    dezeseis,
    quinze,
    quatorze,
    treze,
    doze,
    onze,
    vinteum,
    vintedois,
    vintetres,
    vintequatro,
    vintecinco,
    vinteseis,
    vintesete,
    vinteoito,
    quarentaoito,
    quarentasete,
    quarentaseis,
    quarentacinco,
    quarentaquatro,
    quarentatres,
    quarentadois,
    quarentaum,
    trintaum,
    tristadois,
    trintatres,
    trintaquatro,
    trintacinco,
    trintaseis,
    trintasete,
    trintaoito,
  } = regiao;

  function handleSubmit() {
    if (uploading) return

    setLoading(true);
    schema
      .validate({
        email: email,
      })
      .then(async () => {
        const res = await api.post('/formulario', {
          nome,
          email,
          telefone,
          whatsapp,
          documento,
          nomepaciente,
          tipodecaso,
          regiaotratamento: regiao,
          marca,
          modelo,
          tipodeprotese,
          coroasprovisoario,
          observacao,
          formaenvio,
          linkwetransfer,
          files,
        });
        console.debug(res.status, res.data)
        if (res.data) {
          setNome('');
          setEmail('');
          setTelefone('');
          setWhatsapp('');
          setDocumento('');
          setNomePaciente('');
          setTipoDeCaso('');
          setMarca('');
          setModelo('');
          setTipoDeProtese('');
          setCoroaProvisoria('');
          setObservacao('');
          setFormaEnvio('');
          setLinkWetransfer('');

          setFormCreated(true);
          setTimeout(() => setFormCreated(false), 3500)
        } else {
          setFormError(true)
          setTimeout(() => setFormError(false), 3500)
        }
      })
      .catch((e) => {
        console.debug(e)
        alert('Por favor preencha o campo email corretamente');
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function uploadsFinished (files) {
    setFiles(files) 
    setUploading(false)
  }

  if (loading) {
    return <h1>Carregando...</h1>;
  } else {
    return (
      <form className={classes.form}>
        <Overlay open={formCreated}>
          <Typography variant='h5' color='white'>
            Formulário enviado com sucesso
          </Typography>
        </Overlay>
        <Overlay open={formError}>
          <Typography variant='h5' color='white'>
            Por favor, insira um email válido
          </Typography>
        </Overlay>
        <Grid container direction='row' justify='center' spacing={1}>
          <Grid container item xs={12} sm={12} direction='row' justify='center' spacing={1}>
            <Grid item xs={10} sm={4}>
              <StdTextField
                label='Nome completo do dentista' 
                value={nome}
                onChange={e => setNome(e.target.value)}
              />
              <StdTextField
                label='Email' 
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </Grid>
            <Grid item xs={0} sm={2} />
            <Grid item xs={10} sm={4}>
              <StdTextField 
                label='Telefone' 
                value={telefone}
                onChange={e => setTelefone(e.target.value)}  
              />
              <StdTextField 
                label='WhatsApp' 
                value={whatsapp}
                onChange={e => setWhatsapp(e.target.value)}  
              />
            </Grid>
          </Grid>
          <Grid container item xs={12} sm={12} direction='row' justify='center' spacing={1}>
            <Grid item xs={10} sm={4}>
              <StdTextField
                label='Nome completo do paciente' 
                value={nomepaciente}
                onChange={e => setNomePaciente(e.target.value)}
              />
            </Grid>
            <Grid item xs={0} sm={2} />
            <Grid item xs={10} sm={4}>
              <StdTextField
                label='Documento (CPF ou CNPJ)' 
                value={documento}
                onChange={e => setDocumento(e.target.value)}
              />
            </Grid>
          </Grid>
          <Grid container item xs={12} sm={12} direction='row' justify='center' spacing={1}>
            <Grid item xs={10} sm={10}>
              <FormControl component="fieldset" className={classes.teethRegionsContainer}>
                <FormLabel component='legend' className={classes.formLabel}>
                  Região do tratamento (nº dos dentes)
                </FormLabel>
                <FormGroup>
                  <div>
                    <AreaDentes>
                      <EspacoDente1>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={dezoito}
                              onChange={HadleRegiao}
                              name="dezoito"
                            />
                          }
                          label="18"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={dezesete}
                              onChange={HadleRegiao}
                              name="dezesete"
                            />
                          }
                          label="17"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={dezeseis}
                              onChange={HadleRegiao}
                              name="dezeseis"
                            />
                          }
                          label="16"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={quinze}
                              onChange={HadleRegiao}
                              name="quinze"
                            />
                          }
                          label="15"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={quatorze}
                              onChange={HadleRegiao}
                              name="quatorze"
                            />
                          }
                          label="14"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={treze}
                              onChange={HadleRegiao}
                              name="treze"
                            />
                          }
                          label="13"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={doze}
                              onChange={HadleRegiao}
                              name="doze"
                            />
                          }
                          label="12"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={onze}
                              onChange={HadleRegiao}
                              name="onze"
                            />
                          }
                          label="11"
                        />
                      </EspacoDente1>
                      <EspacoDente2>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={vinteum}
                              onChange={HadleRegiao}
                              name="vinteum"
                            />
                          }
                          label="21"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={vintedois}
                              onChange={HadleRegiao}
                              name="vintedois"
                            />
                          }
                          label="22"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={vintetres}
                              onChange={HadleRegiao}
                              name="vintetres"
                            />
                          }
                          label="23"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={vintequatro}
                              onChange={HadleRegiao}
                              name="vintequatro"
                            />
                          }
                          label="24"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={vintecinco}
                              onChange={HadleRegiao}
                              name="vintecinco"
                            />
                          }
                          label="25"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={vinteseis}
                              onChange={HadleRegiao}
                              name="vinteseis"
                            />
                          }
                          label="26"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={vintesete}
                              onChange={HadleRegiao}
                              name="vintesete"
                            />
                          }
                          label="27"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={vinteoito}
                              onChange={HadleRegiao}
                              name="vinteoito"
                            />
                          }
                          label="28"
                        />
                      </EspacoDente2>
                    </AreaDentes>
                    <AreaDentes>
                      <EspacoDente3>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={quarentaoito}
                              onChange={HadleRegiao}
                              name="quarentaoito"
                            />
                          }
                          label="48"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={quarentasete}
                              onChange={HadleRegiao}
                              name="quarentasete"
                            />
                          }
                          label="47"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={quarentaseis}
                              onChange={HadleRegiao}
                              name="quarentaseis"
                            />
                          }
                          label="46"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={quarentacinco}
                              onChange={HadleRegiao}
                              name="quarentacinco"
                            />
                          }
                          label="45"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={quarentaquatro}
                              onChange={HadleRegiao}
                              name="quarentaquatro"
                            />
                          }
                          label="44"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={quarentatres}
                              onChange={HadleRegiao}
                              name="quarentatres"
                            />
                          }
                          label="43"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={quarentadois}
                              onChange={HadleRegiao}
                              name="quarentadois"
                            />
                          }
                          label="42"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={quarentaum}
                              onChange={HadleRegiao}
                              name="quarentaum"
                            />
                          }
                          label="41"
                        />
                      </EspacoDente3>
                      <EspacoDente4>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={trintaum}
                              onChange={HadleRegiao}
                              name="trintaum"
                            />
                          }
                          label="31"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={tristadois}
                              onChange={HadleRegiao}
                              name="tristadois"
                            />
                          }
                          label="32"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={trintatres}
                              onChange={HadleRegiao}
                              name="trintatres"
                            />
                          }
                          label="33"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={trintaquatro}
                              onChange={HadleRegiao}
                              name="trintaquatro"
                            />
                          }
                          label="34"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={trintacinco}
                              onChange={HadleRegiao}
                              name="trintacinco"
                            />
                          }
                          label="35"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={trintaseis}
                              onChange={HadleRegiao}
                              name="trintaseis"
                            />
                          }
                          label="36"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={trintasete}
                              onChange={HadleRegiao}
                              name="trintasete"
                            />
                          }
                          label="37"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={trintaoito}
                              onChange={HadleRegiao}
                              name="trintaoito"
                            />
                          }
                          label="38"
                        />
                      </EspacoDente4>
                    </AreaDentes>
                  </div>
                </FormGroup>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container item xs={12} sm={12} direction='row' justify='center' spacing={1}>
            <Grid item xs={10} sm={4}>
              <StdTextField
                label='Marca' 
                value={marca}
                onChange={e => setMarca(e.target.value)}
              />
              <StdTextField
                label='Modelo' 
                value={modelo}
                onChange={e => setModelo(e.target.value)}
              />
            </Grid>
            <Grid item xs={10} sm={2}>
              <FormControl component="fieldset" className={classes.radioGroup}>
                <FormLabel component='legend' className={classes.formLabel}>Tipo de caso</FormLabel>
                <RadioGroup
                  aria-label="tipocaso"
                  name="gender1"
                  value={tipodecaso}
                  onChange={(e) => {
                    setTipoDeCaso(e.target.value);
                  }}
                >
                  <FormControlLabel
                    value="UNITARIO"
                    control={<Radio classes={radioClasses}/>}
                    label="UNITÁRIO"
                  />
                  <FormControlLabel
                    value="MULTIPLO"
                    control={<Radio classes={radioClasses}/>}
                    label="MÚLTIPLO"
                  />
                  <FormControlLabel
                    value="ARCOTOTAL"
                    control={<Radio classes={radioClasses}/>}
                    label="ARCO TOTAL"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={10} sm={4}>
              <FormControl component="fieldset" className={classes.radioGroup}>
              <FormLabel component='legend' className={classes.formLabel}>
                Deseja solicitar o envio de coroas provisórioas para instalação imediata nesse caso?
              </FormLabel>
              <RadioGroup
                aria-label="gender"
                name="gender1"
                value={coroasprovisoario}
                onChange={(e) => {
                  setCoroaProvisoria(e.target.value);
                }}
              >
                <FormControlLabel
                  value="SIM"
                  control={<Radio classes={radioClasses} />}
                  label="SIM"
                />
                <FormControlLabel
                  value="NAO"
                  control={<Radio classes={radioClasses} />}
                  label="NÃO"
                />
              </RadioGroup>
            </FormControl>
            </Grid>
          </Grid>
          <Grid container item xs={12} sm={12} direction='row' justify='center' spacing={1}>
            <Grid item xs={10} sm={6}>
              <FormLabel component='legend' className={classes.textareaLabel}>
                Observações sobre o caso:
              </FormLabel>
              <TextareaAutosize 
                className={classes.textarea}
                rowsMax={12} 
                rowsMin={4} 
                aria-label="observações" 
                placeholder="Ex.: obturação"
              />
              <StdTextField
                label='Link we-transfer' 
                value={linkwetransfer}
                onChange={e => setLinkWetransfer(e.target.value)}
              />
            </Grid>
            <Grid item xs={10} sm={4}>
              <FormControl component="fieldset" className={classes.radioGroup}>
                <FormLabel component='legend' className={classes.formLabel}>
                  Forma de envio do guia cirúrgico
                </FormLabel>
                <RadioGroup
                  aria-label="gender"
                  name="gender1"
                  value={formaenvio}
                  onChange={(e) => {
                    setFormaEnvio(e.target.value);
                  }}
                >
                  <FormControlLabel
                    value="MOTOBOY"
                    control={<Radio classes={radioClasses} />}
                    label="MOTOBOY (SOMENTE CURITIBA)"
                  />
                  <FormControlLabel
                    value="SEDEX10"
                    control={<Radio classes={radioClasses} />}
                    label="SEDEX 10"
                  />
                  <FormControlLabel
                    value="SEDEX"
                    control={<Radio classes={radioClasses} />}
                    label="SEDEX"
                  />
                  <FormControlLabel
                    value="PAC"
                    control={<Radio classes={radioClasses} />}
                    label="PAC"
                  />
                  <FormControlLabel
                    value="AEREO"
                    control={<Radio classes={radioClasses} />}
                    label="AÉREO"
                  />
                  <FormControlLabel
                    value="RODOVIARIO"
                    control={<Radio classes={radioClasses} />}
                    label="RODOVIÁRIO"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container item xs={12} sm={12} direction='row' justify='center' spacing={1}>
            <Grid item xs={10}>
              <MultiFileUpload 
                onUploading={() => setUploading(true)}
                onAllFinished={uploadsFinished}  
              />
            </Grid>
            <Grid item xs={10}>
              <Button onClick={() => handleSubmit()} className={classes.button}>
                ENVIAR
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    )
  }
}
